// Import the functions you need from the SDKs you need
import Firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/storage";
// TO BE USED
import "firebase/compat/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAogv7MTSElhy8Z5odXCyNvMQzHFcF_FoA",
  authDomain: "uusisivu-c4c38.firebaseapp.com",
  projectId: "uusisivu-c4c38",
  storageBucket: "uusisivu-c4c38.appspot.com",
  messagingSenderId: "34449683148",
  appId: "1:34449683148:web:6e22b1108259312d968869",
  measurementId: "G-GP43QTJRF7"
};

// Initialize Firebase
export const firebase = Firebase.initializeApp(firebaseConfig);
export const storage = firebase.storage();
export const db = firebase.firestore();



